// 是否存在结算信息
function isRemainSettlement(_this) {
  const { storeId, status, settlementAccount } = _this.$store.state.storeInfo
  const isRemain = !!settlementAccount?.bankName
  if (!isRemain) {
    _this.$confirm(_this.$t('login.providingSettlementProceeds'), _this.$t('login.unlockRightSettlementInfo'), {
      distinguishCancelAndClose: true,
      confirmButtonText: _this.$t('login.completeNow'),
      cancelButtonText: _this.$t('login.cancel')
    })
      .then(() => {
        _this.$router.push(`/seller-center/application/store/qualification/${storeId}?status=${status}`)
      })
  }
  return isRemain
}

export default ({ app }, inject) => {
// 异常提示
  inject('isRemainSettlement', (_this) => isRemainSettlement(_this))
}
